module.exports = __webpack_public_path__ + "static/media/university.c9658e90.png";